module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-66-min.2e674e93.jpg";